(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', '../core/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('../core/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.convert);
    global.subtract = mod.exports;
  }
})(this, function (exports, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.subtract = undefined;


  /**
   * Replaces by the subtraction of the former number by the given number.
   * @function
   * @memberof lang
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {number} subtrahend The number to subtract.
   * @return {Object} Returns the updated object.
   * @example subtract({ nested: { prop: 2000 } }, 'nested.prop', 336) // => { nested: { prop: 1664 } }
   * @since 1.0.0
   */
  var subtract = (0, _convert.convert)(function (value, subtraction) {
    return Number(value) - Number(subtraction);
  });

  exports.subtract = subtract;
});